import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Row, Spin, Typography } from 'antd';
import { StatusColors, type UploadedFile } from './types';

const { Text } = Typography;

type UploadedFileStatusProps = {
    uploadedFiles: UploadedFile[];
    removeFilefromList: (fileName: string) => void;
    currentStep: number;
};

export function UploadedFileStatus(props: UploadedFileStatusProps) {
    const { uploadedFiles, removeFilefromList, currentStep } = props;

    return (
        <Row className='card-body border'>
            <table>
                <tbody>
                    {uploadedFiles.map((uploadedFile) => (
                        <tr key={uploadedFile.id}>
                            <td>
                                <Text style={{ color: StatusColors[uploadedFile.status] }}>
                                    <PaperClipOutlined />
                                    {uploadedFile.file.name}:
                                </Text>
                            </td>

                            <td>
                                <Text style={{ color: StatusColors[uploadedFile.status] }}>
                                    {uploadedFile.msg}
                                </Text>
                            </td>

                            {currentStep === 0 && (
                                <td>
                                    <Button
                                        onClick={() => removeFilefromList(uploadedFile.file.name)}
                                        type='text'
                                    >
                                        <DeleteOutlined
                                            style={{ color: StatusColors[uploadedFile.status] }}
                                        />
                                    </Button>
                                </td>
                            )}

                            {currentStep === 1 && uploadedFile.status === 'aguardando' && (
                                <td>
                                    <Spin size='small' spinning={true} />
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Row>
    );
}
